// Mongoose shim for frontend compatibility
// The @shoutout-labs/market_buzz_crm_types package uses mongoose.Types.ObjectId
// but mongoose is a backend library. This shim provides the necessary interface.
//
// CRITICAL: This shim MUST be loaded before any code that uses mongoose.
// The shim is also defined in index.html as a synchronous script to ensure
// it's available before any modules load.

// ObjectId constructor function - can be called with or without 'new'
// In frontend, we just return the string ID since backend will handle ObjectId conversion
const ObjectIdConstructor = function (this: any, id?: string | any) {
  const result = id ? String(id) : "000000000000000000000000";

  // If called with 'new', create an object-like wrapper
  if (new.target || this instanceof ObjectIdConstructor) {
    const obj = {
      toString: () => result,
      valueOf: () => result,
      toHexString: () => result,
      toJSON: () => result
    };
    // Make it look like an ObjectId instance
    Object.setPrototypeOf(obj, ObjectIdConstructor.prototype);
    return obj;
  }

  // If called as function (without 'new'), return string directly
  return result;
} as any;

// Add prototype methods for ObjectId-like behavior
ObjectIdConstructor.prototype = {
  toString: function () {
    return String(this);
  },
  valueOf: function () {
    return String(this);
  }
};

const mongooseShim = {
  Types: {
    ObjectId: ObjectIdConstructor
  }
};

// Make it available globally for CommonJS require() calls
// This ensures mongoose is available when the types package uses require('mongoose')
// We set it on all possible global contexts to ensure maximum compatibility
if (typeof globalThis !== "undefined") {
  (globalThis as any).mongoose = mongooseShim;
}
if (typeof window !== "undefined") {
  (window as any).mongoose = mongooseShim;
}
// eslint-disable-next-line no-undef
if (typeof global !== "undefined") {
  // eslint-disable-next-line no-undef
  (global as any).mongoose = mongooseShim;
}
// eslint-disable-next-line no-undef
if (typeof self !== "undefined") {
  // eslint-disable-next-line no-undef
  (self as any).mongoose = mongooseShim;
}

// ES module exports
export const mongoose = mongooseShim;
export default mongooseShim;
// Named export for Types - allows: import { Types } from 'mongoose'
export const Types = mongooseShim.Types;

// CommonJS exports for require() compatibility
// This ensures the shim works when CommonJS code does require('mongoose')
// Note: In Vite, CommonJS is transformed, but this provides a fallback
if (typeof module !== "undefined" && typeof module.exports !== "undefined") {
  module.exports = mongooseShim;
  (module.exports as any).default = mongooseShim;
  (module.exports as any).mongoose = mongooseShim;
  (module.exports as any).Types = mongooseShim.Types;
}
